"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var util_localization_1 = __importStar(require("@sport-thieme/util-localization"));
var __1 = require("../..");
var styles_1 = require("@material-ui/core/styles");
var List_1 = require("../../List");
var __2 = require("../..");
var core_1 = require("@material-ui/core");
var ThemeProvider_1 = require("../../ThemeProvider");
var moment_1 = __importDefault(require("moment"));
util_localization_1.default.addTranslations('de', {
    'Last build: $0': 'Letztes Build: $0',
});
function Menu(_a) {
    var _b;
    var username = _a.username, signOut = _a.signOut, anchorEl = _a.anchorEl, onClose = _a.onClose, menuItems = _a.menuItems;
    var classes = styles();
    var _c = ThemeProvider_1.useDarkMode(), darkMode = _c[0], setDarkMode = _c[1];
    return (jsx_runtime_1.jsxs(__1.Menu, __assign({ keepMounted: true, anchorEl: anchorEl, open: Boolean(anchorEl), onClose: onClose, getContentAnchorEl: null, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        } }, { children: [username !== undefined && (jsx_runtime_1.jsx(__1.MenuItem, __assign({ className: classes.user, button: false }, { children: username }), void 0)), menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(function (item, index) { return (jsx_runtime_1.jsxs(__1.MenuItem, __assign({}, item, { children: [item.icon && jsx_runtime_1.jsx(List_1.ListItemIcon, { children: item.icon }, void 0),
                    jsx_runtime_1.jsx(core_1.ListItemText, { children: item.label }, void 0)] }), "" + item.key + index)); }), jsx_runtime_1.jsxs(__1.MenuItem, __assign({ onClick: function () { return setDarkMode(!darkMode); } }, { children: [jsx_runtime_1.jsx(List_1.ListItemIcon, { children: darkMode ? jsx_runtime_1.jsx(__2.Icon.Brightness7, {}, void 0) : jsx_runtime_1.jsx(__2.Icon.Brightness4, {}, void 0) }, void 0),
                    jsx_runtime_1.jsx(core_1.ListItemText, { children: darkMode ? util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Turn off darkmode"], ["Turn off darkmode"]))) : util_localization_1.localize(templateObject_2 || (templateObject_2 = __makeTemplateObject(["Turn on darkmode"], ["Turn on darkmode"]))) }, void 0)] }), void 0),
            ((_b = process.env) === null || _b === void 0 ? void 0 : _b.REACT_APP_DEPLOYMENT_TIMESTAMP) && (jsx_runtime_1.jsxs(__1.MenuItem, __assign({ button: false }, { children: [jsx_runtime_1.jsx(List_1.ListItemIcon, { children: jsx_runtime_1.jsx(__2.Icon.Build, {}, void 0) }, void 0),
                    jsx_runtime_1.jsx(core_1.ListItemText, { children: util_localization_1.localize(templateObject_3 || (templateObject_3 = __makeTemplateObject(["Last build: ", ""], ["Last build: ",
                            ""])), moment_1.default
                            .unix(parseInt(process.env.REACT_APP_DEPLOYMENT_TIMESTAMP, 10))
                            .fromNow()) }, void 0)] }), void 0)),
            Boolean(signOut) && (jsx_runtime_1.jsxs(__1.MenuItem, __assign({ onClick: signOut }, { children: [jsx_runtime_1.jsx(List_1.ListItemIcon, { children: jsx_runtime_1.jsx(__2.Icon.ExitToAppOutlined, {}, void 0) }, void 0),
                    jsx_runtime_1.jsx(core_1.ListItemText, { children: util_localization_1.localize(templateObject_4 || (templateObject_4 = __makeTemplateObject(["Logout"], ["Logout"]))) }, void 0)] }), void 0))] }), void 0));
}
exports.default = Menu;
var styles = styles_1.makeStyles({
    user: {
        outline: 0,
    },
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Menu.js.map